import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const InteractionsModelSchema = z
  .object({
    id: z.string(),
    subject: z.string(),
    type: z.string(),
    owner: z.string().nullish(),
    datetime: z.string(),
    description: z.string().nullish(),
    notes: z.string().nullish()
  })
  .strict()

export const InteractionsModelFields = makeFieldKeys(InteractionsModelSchema)

export type InteractionsModel = z.infer<typeof InteractionsModelSchema>

function validateInteractionsModel(data: unknown): InteractionsModel {
  try {
    return validateWithZodSchema(InteractionsModelSchema, data, 'interactions model')
  } catch (error) {
    throw new Error(`Interactions model validation failed: ${error}`)
  }
}
